module.exports = {
      id: "ic-spline-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-spline-normal-usage",
      toString: function () {
        return this.url;
      }
    }